<template>
  <v-card class="transparent elevation-0">
    <v-card-text class="pa-8 white elevation-3 rounded-lg">
      <p class="font-weight-bold text-subtitle-1">{{ $t('label.howToUse') }}</p>
      <p class="text-body-2">{{ uses }}</p>
      <p class="font-weight-bold text-subtitle-1">{{ $t('label.benefits') }}</p>
      <p class="text-body-2">{{ benefits }}</p>
      <p class="font-weight-bold text-subtitle-1">{{ $t('label.keyIngredients') }}</p>
      <p class="text-body-2">{{ ingredients }}</p>
    </v-card-text>
    <v-card-actions class="transparent">
      <v-btn color="transparent mx-auto" depressed fab @click="$emit('input', false)">
        <v-icon x-large class="transparent grey--text text--lighten-2">mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    uses: { type: String },
    benefits: { type: String },
    ingredients: { type: String }
  }
}
</script>
